export enum SignatoryStatusEnum {
  InSubscription = 'emAssinatura',
  Canceled = 'cancelado',
  Finished = 'finalizado',
  Expired = 'expirado',
}
